/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Account')
    .directive('accNotificationsButton', ['AccountNotifications' ,'editNotificationShare', '$rootScope',
            function(AccountNotifications, editNotificationShare, $rootScope) {
        return {
            link: function($scope){
                $scope.editNotificationShare = function() {
                    var share = $scope.node;
                    if (!$rootScope.account.notificationDefault) {
                        AccountNotifications.get({}, function(defaultNotifications){
                            $rootScope.account.notificationDefault = defaultNotifications;
                        });
                    }
                    editNotificationShare.showDialog(share);
                }
            }
        }
    }]);